export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-mask/index.js